import React from 'react'
import { useIntl } from 'react-intl'
import Modal from '../../../components/modal/Modal'
import useModal from '../../../utils/hooks/useModal'
import ChangePriceForm from '../../../components/fuel-stations/fuel-prices/ChangePriceForm'
import useAccess from '../../../utils/hooks/useAccess'
import { MineturPricesService } from '../../../services/prices-fuel-stations/pricesFuelStations.service'
import { GROUPS, MODULES } from '../../../utils/constants/roles'
import PriceHistoryDataTable from '../../../components/fuel-stations/fuel-prices/PriceHistoryDataTable'
import useHandlerBasicActions from '../../../utils/hooks/useHandlerBasicActions'
import MainCommonView from '../../../components/common/MainCommonView'
import AppSection from '../../../component/layout/AppSection.tsx'
import AppTabMenu from '../../../component/layout/AppTabMenu.tsx'
import { fuelStationsMenu } from '../../../utils/constants/navlinks-Menu'

const FuelStationsPrices = () => {
  const { formatMessage: msg } = useIntl()

  const { isShowing, toggle } = useModal()
  const { canAdd } = useAccess()

  const dataFacade = useHandlerBasicActions({
    getAll: MineturPricesService.getPrices,
    sortFieldInitial: 'createdAt',
    sortInit: -1,
    rowsPerPageInitial: 100,
  })

  const handleSubmit = () => {
    dataFacade.reload()
    toggle()
  }

  const headerOptions = {
    title: msg({ id: 'fuels.prices.change' }),
    handlerHeaderActions: {
      secondaryButton: canAdd(MODULES.FUELSTATIONS, GROUPS.PRICES) && toggle,
      secondaryButtonText: 'button.change.prices',
      secondaryButtonIcon: 'euro',
    },
    searchOptions: dataFacade?.searchOptions,
  }

  const pagerOptions = {
    ...dataFacade?.pagerOptions,
    totalRecords: dataFacade?.data?.total,
  }

  return (
    <AppSection
      /* refactor this */
      header={<AppTabMenu options={fuelStationsMenu} />}
      headerOptions={headerOptions}
      dataFacade={dataFacade}
    >
      <PriceHistoryDataTable
        pagerOptions={pagerOptions}
        prices={dataFacade?.data?.resp}
        isSeeCenter
        sortOptions={dataFacade?.sortOptions}
      />
      <Modal
        isShowing={isShowing}
        hide={toggle}
        width="90%"
        maxWidth="1200px"
        title={msg({ id: 'fuels.price.change' })}
        context={<ChangePriceForm handleSubmit={handleSubmit} />}
      />
    </AppSection>
  )
}

export default FuelStationsPrices
